import type { CalendarEvent, MapPoint, WorkingHoursEntry } from "@ondetatu/shared";
import { api } from "./client.js";

export type { CalendarEvent, MapPoint, WorkingHoursEntry };

export const viewsApi = {
  map: (asOf?: string) =>
    api.get<{ asOf: string; points: MapPoint[] }>(`/api/views/map${asOf ? `?as_of=${asOf}` : ""}`),
  calendar: (from?: string, to?: string) => {
    const qs = new URLSearchParams();
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    const q = qs.toString();
    return api.get<{ events: CalendarEvent[] }>(`/api/views/calendar${q ? `?${q}` : ""}`);
  },
  workingHours: () => api.get<{ entries: WorkingHoursEntry[] }>("/api/views/working-hours"),
};
